import { render, staticRenderFns } from "./ValidateEmailRegistration.vue?vue&type=template&id=4214184f&scoped=true"
import script from "./ValidateEmailRegistration.vue?vue&type=script&lang=js"
export * from "./ValidateEmailRegistration.vue?vue&type=script&lang=js"
import style0 from "./ValidateEmailRegistration.vue?vue&type=style&index=0&id=4214184f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4214184f",
  null
  
)

export default component.exports